const testEnv = {
	STAGE_TYPE: 'test',
	API_HOST: 'https://www.daserste.de/ard/die-ard/ard-home/index~feed.json',
	MT_HOST: 'https://test.ardmediathek.de',
	ATI_ENVIRONMENT_ID: '511894',
};
export default testEnv;
